// extracted by mini-css-extract-plugin
export default {"Container":"Submit_Container__Wej9Q","Barcode":"Submit_Barcode__2UdMO"};